import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M4.6084935,3.06259159 C4.34479926,2.89472661 4,3.08937447 4,3.41815462 L4,12.5850434 C4,12.9138235 4.34479926,13.1084714 4.6084935,12.9406064 L11.8084935,8.35716202 C12.0638355,8.19461399 12.0638355,7.80858401 11.8084935,7.64603598 L4.6084935,3.06259159 Z M5.1455046,2.21901641 L12.3455046,6.8024608 C13.2181651,7.35798733 13.2181651,8.64521067 12.3455046,9.2007372 L5.1455046,13.7841816 C4.21031242,14.3795151 3,13.6962633 3,12.5850434 L3,3.41815462 C3,2.30693471 4.21031242,1.6236829 5.1455046,2.21901641 Z"/>
  </svg>
);
